import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { fetchOrderById, fetchOrders } from '../slices/ordersSlice';
import { fetchClientById, fetchClientsOrder } from '../slices/clientSlice';
import Header from '../components/Header';
import Sidebar from '../components/Sidebar';
// import SummaryBtns from '../components/SummaryBtns';
import {
	Sliders,
	PlusSquare,
	File,
	Smile,
	ArrowRight,
	ArrowLeft,
} from 'react-feather';
import OrderDetails from '../components/OrderDetails';
import Checklist from '../components/Checklist';
import { statusMapping } from '../formData/generalData';
import BncLogoSpinner from '../components/BncLogoSpinner';
import { formatPhoneNumber, removePhoneFormatting } from '../hooks/phoneFormat';
import useDebounce from '../hooks/useDebounce';

export default function Leads() {
	const dispatch = useDispatch();
	const navigate = useNavigate();
	const orders = useSelector((state) => state?.orders?.items);
	const error = useSelector((state) => state.orders.error);
	const [selectedOrder, setSelectedOrder] = useState(null);
	const [selectDetials, setSelectDetails] = useState(false);

	// Search bar

	const [clientFirstName, setClientFirstName] = useState('');
	const [clientLastName, setClientLastName] = useState('');
    const [clientPhone, setClientPhone] = useState('');
	const [deliveryPostalCode, setDeliveryPostalCode] = useState('');
	const [pageSize, setPageSize] = useState(100);
	const [currentPage, setCurrentPage] = useState(1);

	// Toggle sections
	const [filterSection, setFilterSections] = useState({
		filterOptions: false,
	});

	// Redux state for orders and clients status
	const ordersStatus = useSelector((state) => state.orders.listStatus);
	const clientsStatus = useSelector((state) => state.clients.listStatus);

	// Debounce search terms
	const debouncedFirstName = useDebounce(clientFirstName, 500);
	const debouncedLastName = useDebounce(clientLastName, 500);
	const debouncedPostalCode = useDebounce(deliveryPostalCode, 500);

	useEffect(() => {
		dispatch(
			fetchOrders({
				pageSize: 500,
				sortOrder: 'DESC',
				status: '1', // Only fetch Leads/Quotes
			})
		);
		dispatch(fetchClientsOrder());
	}, [dispatch]);

	// Removed early return for loading to prevent component unmount/remount flickering
	// if (ordersStatus === 'loading' || clientsStatus === 'loading') {
	// 	return <BncLogoSpinner />;
	// }

	// You can also add a more specific error check
	// Non-blocking error handling - error will be displayed in main UI

	const openDetails = (order, clientId) => {
		setSelectedOrder(order);

		if (order?.id) {
			dispatch(fetchOrderById(order.id));
		}
		if (clientId) {
			dispatch(fetchClientById(clientId));
		}
	};

	const openCheckList = (workOrders) => {
		setSelectDetails(workOrders);
	};


	// Toggle sections

	const toggleSection = (filterSection) => {
		setFilterSections((prevSections) => ({
			...prevSections,
			[filterSection]: !prevSections[filterSection],
		}));
	};

	// Search filters

	const applyFilters = (e) => {
        e?.preventDefault();
        setCurrentPage(1);
	};

	const resetFilters = (e) => {
        e?.preventDefault();
		setClientFirstName('');
		setClientLastName('');
		setDeliveryPostalCode('');
		setCurrentPage(1);
	};

	const handleNextPage = (e) => {
        e.preventDefault();
		setCurrentPage((prevPage) => prevPage + 1);
	};

	const handlePreviousPage = (e) => {
        e.preventDefault();
		setCurrentPage((prevPage) => Math.max(prevPage - 1, 1));
	};

	return (
		<div className="flex flex-col h-screen">
			<Header />
			<div className="flex flex-1 overflow-hidden">
				<Sidebar />
				<main className="flex-1 overflow-y-auto bg-slate-50 modern-dashboard">
					<div className="content-header">
						<h1>
							<Smile size={32} /> Leads Management
						</h1>
					</div>

					<div className="table-card relative">
                        {/* Error Alert */}
                        {ordersStatus === 'failed' && (
                            <div className="bg-red-50 border-l-4 border-red-500 text-red-700 p-4 mb-4 mx-4 mt-4" role="alert">
                                <p className="font-bold">Error loading orders</p>
                                <p>{error?.message || JSON.stringify(error) || 'Unknown error occurred while fetching data.'}</p>
                            </div>
                        )}

                        {/* Loading Overlay */}
                        {(ordersStatus === 'loading' || clientsStatus === 'loading') && (
                            <div className="absolute inset-0 bg-white/50 z-10 flex items-center justify-center">
                                <BncLogoSpinner />
                            </div>
                        )}

						<div className="action-row">
							<div className="search-wrapper">
								<Sliders size={18} />
								<input 
									type="text" 
									placeholder="Quick search leads..." 
									value={clientFirstName}
									onChange={(e) => {
                                        setClientFirstName(e.target.value);
                                        setCurrentPage(1); // Reset to page 1 on search
                                    }}
								/>
							</div>
							<div className="flex gap-2">
								<button 
                                    type="button"
									className="quick-access-btn"
									onClick={() => toggleSection('filterOptions')}
								>
									<span>All Filters</span>
								</button>
								<button 
                                    type="button"
									className="quick-access-btn primary"
									onClick={() => navigate('/new-quote')}
								>
									<PlusSquare size={20} />
									<span>Start a new Quote</span>
								</button>
							</div>
						</div>

						{filterSection.filterOptions && (
							<div className="filters-grid">
								<input
									type="text"
									placeholder="First name"
									value={clientFirstName}
									onChange={(e) => setClientFirstName(e.target.value)}
								/>
								<input
									type="text"
									placeholder="Last name"
									value={clientLastName}
									onChange={(e) => setClientLastName(e.target.value)}
								/>
                                <input
									type="text"
									placeholder="Phone"
									value={formatPhoneNumber(clientPhone)}
									onChange={(e) => setClientPhone(e.target.value)}
								/>
								<div className="flex gap-2">
									<input
										type="number"
										className="w-24"
										placeholder="Page size"
										value={pageSize}
										onChange={(e) => setPageSize(e.target.value)}
									/>
									<div className="filter-btn-group flex-1">
										<button type="button" onClick={applyFilters} className="search">Search</button>
										<button type="button" onClick={resetFilters} className="reset">Reset</button>
									</div>
								</div>
							</div>
						)}

						<table className="modern-table">
							<thead>
								<tr>
									<th>Customer</th>
									<th>Order ID</th>
									<th>Date</th>
									<th>Status</th>
									<th>Email</th>
									<th className="text-right">Actions</th>
								</tr>
							</thead>
							<tbody>
								{orders
                                    .filter(order => {
                                        // 1. Strict Phone Filter
                                        if (clientPhone) {
                                            const qPhone = clientPhone.replace(/\D/g, '');
                                            const oPhone = (order.clientPhoneNumber || '').replace(/\D/g, '');
                                            if (qPhone.length > 0 && !oPhone.includes(qPhone)) return false;
                                        }

                                        // 2. Strict Last Name Filter
                                        if (clientLastName) {
                                             if (!(order.clientName || '').toLowerCase().includes(clientLastName.toLowerCase())) return false; 
                                        }
                                        
                                        // Quick Search / First Name (sends to search bar)
                                        if (!clientFirstName) return true;
                                        const query = clientFirstName.toLowerCase();
                                        const queryPhone = query.replace(/\D/g, '');
                                        
                                        return (
                                            (order.clientName || '').toLowerCase().includes(query) ||
                                            (order.clientEmail || '').toLowerCase().includes(query) ||
                                            (order.reference || '').toString().toLowerCase().includes(query) ||
                                            (queryPhone.length > 2 && (order.clientPhoneNumber || '').replace(/\D/g, '').includes(queryPhone)) ||
                                            (order.deliveryCity || '').toLowerCase().includes(query)
                                        );
                                    })
                                    .map((order, index) => (
										<tr key={order.id} onClick={() => openDetails(order, order.clientId)}>
											<td>
												<div className="flex items-center gap-3">
													<div className={`avatar-initials bg-avatar-${(index % 5) + 1}`}>
														{order.clientName?.split(' ').map(n => n[0]).join('').toUpperCase() || '??'}
													</div>
													<div className="font-semibold text-slate-800">
														{order.clientName}
													</div>
												</div>
											</td>
											<td>
												<strong className="text-blue-600 font-mono">{order.reference}</strong>
											</td>
											<td>
												{new Date(order.createdAt).toLocaleString('en-US', {
													month: '2-digit',
													day: '2-digit',
													year: '2-digit',
												})}
											</td>
											<td>
												<span className="status-pill status-Quote">
													{statusMapping[order.status]}
												</span>
											</td>
											<td className="text-slate-500 text-sm">
                                                <div>{order.clientEmail}</div>
                                                <div className="text-xs text-slate-400">{order.clientPhoneNumber}</div>
                                            </td>
											<td className="text-right">
												<button
                                                    type="button"
													onClick={(e) => {
														e.stopPropagation();
														openDetails(order, order.clientId);
													}}
													className="p-2 text-slate-400 hover:text-blue-600 transition-colors"
													title="View Details"
												>
													<File size={20} />
												</button>
											</td>
										</tr>
									))}
                                {orders.length === 0 && ordersStatus !== 'loading' && (
                                    <tr>
                                        <td colSpan="6" className="text-center py-8 text-slate-500">
                                            No leads found.
                                        </td>
                                    </tr>
                                )}
							</tbody>
						</table>

						<div className="pagination-modern">
							<div className="pagination-info">
								Page <strong>{currentPage}</strong>
							</div>
							<div className="pagination-btns">
								<button type="button" onClick={handlePreviousPage} disabled={currentPage === 1}>
									<ArrowLeft size={18} /> Prev
								</button>
								<button type="button" onClick={handleNextPage} disabled={orders.length < pageSize}>
									Next <ArrowRight size={18} />
								</button>
							</div>
						</div>
					</div>
				</main>

				{/* Panels rendered outside <main> to avoid click-bubbling from table rows */}
				{selectedOrder && (
					<OrderDetails
						order={selectedOrder}
						onClose={() => {
							setSelectedOrder(null);
						}}
					/>
				)}
				{selectDetials && (
					<Checklist
						workOrders={selectDetials}
						onClose={() => setSelectDetails(null)}
					/>
				)}
			</div>
		</div>
	);
}
